import { NextResponse } from "next/server";
import { cookies } from "next/headers";
import {
  ChatAppID,
  ChatRegion,
  ChatRestAPIKey,
} from "@/Utils/APIRequest/Endpoints";

export async function GET(req) {
  try {
    const { searchParams } = new URL(req.url);
    const groupId = searchParams.get("groupId");

    if (!groupId) {
      return NextResponse.json(
        { error: "Group ID is required" },
        { status: 400 }
      );
    }

    // Get auth token from cookies or Authorization header
    // Note: cookies() returns a Promise in Next.js 15+, must await it
    const cookieStore = await cookies();
    let authToken = cookieStore.get("cc_auth")?.value;
    
    // Fallback: Check Authorization header if cookie is not available
    if (!authToken) {
      const authHeader = req.headers.get("authorization");
      if (authHeader && authHeader.startsWith("Bearer ")) {
        authToken = authHeader.substring(7);
      }
    }

    if (!authToken) {
      return NextResponse.json(
        { error: "Authentication required" },
        { status: 401 }
      );
    }

    const url = `https://${ChatAppID}.api-${ChatRegion}.cometchat.io/v3/groups/${groupId}/messages`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        apikey: ChatRestAPIKey,
        Authorization: `Bearer ${authToken}`,
      },
    };

    const response = await fetch(url, options);
    const data = await response.json();

    if (!response.ok) {
      return NextResponse.json(
        { error: data.error || "Failed to fetch messages" },
        { status: response.status }
      );
    }

    return NextResponse.json({ data: data.data || [] });
  } catch (error) {
    console.error("Error fetching messages:", error);
    return NextResponse.json(
      { error: "Something went wrong" },
      { status: 500 }
    );
  }
}
